<template>
  <div id="post-filter-type-id-select">
    <label class="form-label">Раздел</label>
    <Multiselect @change="onChange" v-model="fields.type_id" mode="tags" placeholder="Выбрать" noResultsText="Результатов не найдено" :close-on-select="true" :options="getValues()" :searchable="true" :trackBy="'title'">
      <template v-slot:tag="{ option, handleTagRemove, disabled }">
        <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
          <div class="user-name">{{ option.title }}</div>
          <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
            <span class="multiselect-tag-remove-icon"></span>
          </span>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-user">
          <div class="user-name"> {{ option.title }}</div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import Multiselect from "@/plugins/multiselect"

export default defineComponent({
  name: "TypeId",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let shopsValues = ref([])

    const fields = reactive({
      type_id: props.data.val,
    })

    onMounted(async () => {
      fields.type_id = props.data.val

      let shops = await getTypeIdsApi()

      setValues(shops);
    })

    watch(() => props.data.val, (val) => {
      fields.type_id = val
    })

    watch(() => props.data.shops, (val) => {
      setValues(val)
    })

    function setValues(items) {
      let filtered = []
      for (let prop in items) {
        let obj = items[prop]

        filtered.push({
          value: obj["value"],
          title: obj["name"],
        })
      }

      shopsValues.value = filtered
    }

    function getValues() {
      return shopsValues.value;
    }

    function onChange(value) {
      fields.type_id = value
      emit("onChange", fields.type_id)
    }

    async function getTypeIdsApi() {
      return [
        { value: 5, name: 'Заметка' },
        { value: 6, name: 'Скидки' },
        { value: 7, name: 'Промокоды' },
        { value: 8, name: 'Акции' },
        { value: 9, name: 'Халява' },
        { value: 10, name: 'Еда и продукты' },
        { value: 12, name: 'Банки' },
        { value: 13, name: 'Игры' },
        { value: 14, name: 'Розыгрыши' },
      ]
    }

    return {
      onChange,
      getValues,
      fields,
    }
  }
})
</script>
